(function () {
  var configElement = document.querySelector(
    '[data-ne-gift-progress-config]'
  );
  var config;

  if (!configElement) return;

  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    console.warn('[NE gift progress config]', error);
    return;
  }

  if (window.__NE_GIFT_PROGRESS_AUTO_STACKED_V14__) return;
  window.__NE_GIFT_PROGRESS_AUTO_STACKED_V14__ = true;

  var THIRD_GOAL_TYPE = config.thirdGoalType;
  var HAS_GIFT_1 = config.hasGift1;
  var HAS_THIRD_GOAL = config.hasThirdGoal;
  var THRESHOLDS = config.thresholds;
  var GIFT_VARIANTS = config.giftVariants;
  var PROGRESS_SCALE = config.progressScale;
  var GIFT_LABEL_1 = config.giftLabel1;
  var GIFT_LABEL_2 = config.giftLabel2;
  var DISCOUNT_GOAL_LABEL = config.discountGoalLabel;
  var COPY = config.copy;

  var pendingCartFetch = null;
  var isAutoAddingGift = false;
  var isRemovingInvalidGifts = false;
  var isDispatchingInternalEvent = false;
  var isSyncingCart = false;
  var hasQueuedSync = false;
  var queuedCart = null;

  function cartUrl(path) {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    return root + path.replace(/^\/+/, '');
  }

  function formatMoney(cents, noDecimals) {
    return window.NE.Utils.formatMoney(cents, { trimTrailingZeros: noDecimals });
  }

  function fetchCart(force) {
    if (!force && pendingCartFetch) return pendingCartFetch;

    pendingCartFetch = fetch(cartUrl('/cart.js') + '?t=' + Date.now(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      },
      cache: 'no-store'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart fetch failed');
        return res.json();
      })
      .finally(function () {
        pendingCartFetch = null;
      });

    return pendingCartFetch;
  }

  function persistCampaignFromUrl() {
    var root = document.querySelector('[data-ne-gift-root]');
    if (!root || root.dataset.neCampaignPersisted === 'true') return Promise.resolve(null);

    var paramKey = root.getAttribute('data-ne-campaign-url-param-key') || '';
    var paramValue = root.getAttribute('data-ne-campaign-url-param-value') || '';
    var campaignPersisted = root.getAttribute('data-ne-campaign-url-persisted') === 'true';

    if (!paramKey || !paramValue || campaignPersisted) return Promise.resolve(null);

    var params = new URLSearchParams(window.location.search || '');

    if (params.get(paramKey) !== paramValue) return Promise.resolve(null);

    root.dataset.neCampaignPersisted = 'true';

    return fetch(cartUrl('/cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          _ne_gift_campaign_param_key: paramKey,
          _ne_gift_campaign_param_value: paramValue
        }
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Campaign marker update failed');
        return res.json();
      })
      .then(function (cart) {
        window.location.reload();
        return cart;
      })
      .catch(function (err) {
        console.warn('[NE gift campaign marker]', err);
        return null;
      });
  }

  function getGiftItems(cart) {
    if (!cart || !Array.isArray(cart.items)) return [];

    return cart.items.filter(function (item) {
      return item.properties && String(item.properties._is_free_gift) === 'true';
    });
  }

  function getGiftLineTotal(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;

    return cart.items.reduce(function (total, item) {
      if (item.properties && String(item.properties._is_free_gift) === 'true') {
        return total + Number(item.final_line_price || item.line_price || item.original_line_price || 0);
      }

      return total;
    }, 0);
  }

  function getCartTotalWithoutGifts(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;

    return cart.items.reduce(function (total, item) {
      if (item.properties && String(item.properties._is_free_gift) === 'true') {
        return total;
      }

      return total + Number(item.final_line_price || item.line_price || 0);
    }, 0);
  }

  function getDiscountedCartTotalWithoutGifts(cart) {
    if (!cart) return 0;

    var ajaxTotal = Number(cart.total_price || 0);
    var giftLineTotal = getGiftLineTotal(cart);
    var discountedTotal = Math.max(0, ajaxTotal - giftLineTotal);

    if (discountedTotal > 0 || ajaxTotal === 0) {
      return discountedTotal;
    }

    return getCartTotalWithoutGifts(cart);
  }

  function giftInCart(cart, variantId) {
    if (!variantId) return false;

    return getGiftItems(cart).some(function (item) {
      return String(item.variant_id) === String(variantId);
    });
  }

  function getGiftThresholdFromItem(item) {
    if (item.properties && item.properties._gift_threshold) {
      return Number(item.properties._gift_threshold || 0);
    }

    if (String(item.variant_id) === String(GIFT_VARIANTS.gift1)) {
      return THRESHOLDS.gift1;
    }

    if (String(item.variant_id) === String(GIFT_VARIANTS.gift2)) {
      return THRESHOLDS.gift2;
    }

    return 0;
  }

  function getDisplayCheckoutTotal(cart) {
    return getDiscountedCartTotalWithoutGifts(cart);
  }

  function getProgress(total) {
    var progress = Math.round((total / PROGRESS_SCALE) * 100);

    if (progress > 100) progress = 100;
    if (progress < 0) progress = 0;

    return progress;
  }

  function getTopMessage(total) {
    if (HAS_THIRD_GOAL && total >= THRESHOLDS.third) {
      if (THIRD_GOAL_TYPE === 'discount') {
        return '<strong>' + DISCOUNT_GOAL_LABEL + '</strong> ' + COPY.discountActive;
      }

      return COPY.allUnlocked;
    }

    if (HAS_GIFT_1 && total >= THRESHOLDS.gift1) {
      if (!HAS_THIRD_GOAL) {
        return COPY.allUnlocked;
      }

      if (THIRD_GOAL_TYPE === 'discount') {
        return COPY.remainingPrefix + ' <strong>' + formatMoney(THRESHOLDS.third - total, true) + '</strong> ' + COPY.remainingConnector + ' ' + DISCOUNT_GOAL_LABEL + ' ' + COPY.discountCheckoutSuffix;
      }

      return COPY.remainingPrefix + ' <strong>' + formatMoney(THRESHOLDS.third - total, true) + '</strong> ' + COPY.remainingConnector + ' ' + GIFT_LABEL_2;
    }

    if (HAS_GIFT_1 && total >= THRESHOLDS.shipping) {
      return COPY.remainingPrefix + ' <strong>' + formatMoney(THRESHOLDS.gift1 - total, true) + '</strong> ' + COPY.remainingConnector + ' ' + GIFT_LABEL_1;
    }

    if (total >= THRESHOLDS.shipping) {
      return COPY.shippingActive;
    }

    return COPY.remainingPrefix + ' <strong>' + formatMoney(THRESHOLDS.shipping - total, true) + '</strong> ' + COPY.remainingConnector + ' ' + COPY.shippingGoalLabel;
  }

  function messageLine(text) {
    return (
      '<div class="ne-gift-message__line">' +
        '<span class="ne-gift-message__check">' +
          '<img src="' + COPY.giftIconUrl + '" alt="" loading="lazy">' +
        '</span>' +
        '<span>' + text + '</span>' +
      '</div>'
    );
  }

  function getGreenMessage(total) {
    if (total >= THRESHOLDS.shipping) {
      return messageLine(COPY.shippingActive);
    }

    return '';
  }

  function getSuppressedGiftVariants() {
    try {
      return JSON.parse(sessionStorage.getItem('ne_suppressed_gifts') || '[]');
    } catch (e) {
      return [];
    }
  }

  function setSuppressedGiftVariants(list) {
    try {
      sessionStorage.setItem('ne_suppressed_gifts', JSON.stringify(list));
    } catch (e) {}
  }

  function suppressGiftVariant(variantId) {
    if (!variantId) return;

    var list = getSuppressedGiftVariants();

    if (list.indexOf(String(variantId)) === -1) {
      list.push(String(variantId));
      setSuppressedGiftVariants(list);
    }
  }

  function unsuppressGiftVariant(variantId) {
    if (!variantId) return;

    var list = getSuppressedGiftVariants().filter(function (id) {
      return String(id) !== String(variantId);
    });

    setSuppressedGiftVariants(list);
  }

  function isGiftSuppressed(variantId) {
    if (!variantId) return false;

    return getSuppressedGiftVariants().indexOf(String(variantId)) !== -1;
  }

  function clearSuppressedGiftsBelowThreshold(cart) {
    var total = getDiscountedCartTotalWithoutGifts(cart);
    var list = getSuppressedGiftVariants();

    list = list.filter(function (variantId) {
      if (HAS_GIFT_1 && String(variantId) === String(GIFT_VARIANTS.gift1)) {
        return total >= THRESHOLDS.gift1;
      }

      if (HAS_THIRD_GOAL && String(variantId) === String(GIFT_VARIANTS.gift2)) {
        return total >= THRESHOLDS.gift2;
      }

      return false;
    });

    setSuppressedGiftVariants(list);
  }

  function getGiftVariantFromCartLine(line, cart) {
    if (!line || !cart || !Array.isArray(cart.items)) return null;

    var key = line.getAttribute('data-key');
    if (!key) return null;

    var item = cart.items.find(function (cartItem) {
      return cartItem.key === key;
    });

    if (
      item &&
      item.properties &&
      String(item.properties._is_free_gift) === 'true'
    ) {
      return item.variant_id;
    }

    return null;
  }

  function updateCheckoutButton(cart) {
    if (window.NEUpdateQuickCartCheckoutTotal) {
      window.NEUpdateQuickCartCheckoutTotal(cart);
      return;
    }

    var btn = document.querySelector('.quick-cart__submit');
    if (!btn) return;

    btn.innerHTML = COPY.checkoutLabel + ' - ' + formatMoney(getDisplayCheckoutTotal(cart));
  }

  function getQuickCartItemByKey(key) {
    if (!key) return null;

    if (window.CSS && typeof CSS.escape === 'function') {
      return document.querySelector('.quick-cart__item[data-key="' + CSS.escape(key) + '"]');
    }

    var items = document.querySelectorAll('.quick-cart__item[data-key]');

    for (var i = 0; i < items.length; i++) {
      if (items[i].getAttribute('data-key') === key) {
        return items[i];
      }
    }

    return null;
  }

  function getGiftOriginalPriceFromDom(variantId) {
    if (!variantId) return 0;

    var button = document.querySelector('[data-ne-add-selected-gift][data-selected-variant="' + variantId + '"]');

    if (!button) return 0;

    return Number(button.dataset.selectedOriginalPrice || 0);
  }

  function syncQuickCartGiftPrices(cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    var displayTotal = getDisplayCheckoutTotal(cart);

    getGiftItems(cart).forEach(function (item) {
      var line = getQuickCartItemByKey(item.key);
      if (!line) return;
      line.classList.add('quick-cart__item--free-gift');

      var priceWrapper = line.querySelector('.quick-cart__item-price-wrapper');

      if (priceWrapper) {
        var originalGiftPrice = getGiftOriginalPriceFromDom(item.variant_id);

        priceWrapper.innerHTML =
          '<div class="q-c-gift-price-block">' +
            '<div class="q-c-gift-badge">' +
              '<img class="q-c-gift-badge-icon" src="' + COPY.giftIconUrl + '" alt="" loading="lazy">' +
              '<span>' + COPY.giftLineBadge + '</span>' +
            '</div>' +
            '<div class="q-c-gift-price">' +
              '<span class="quick-cart__item-price q-c-gift-free-price">' + COPY.giftPrice + '</span>' +
              (originalGiftPrice > 0 ? '<s>' + formatMoney(originalGiftPrice) + '</s>' : '') +
            '</div>' +
          '</div>';
      }

      var quantityInput = line.querySelector('.quantity-input, [data-quantity-input], quantity-input');

      if (quantityInput) {
        quantityInput.remove();
      }
    });

    document.querySelectorAll('.quick-cart__footer-subtotal-wrap').forEach(function (el) {
      el.textContent = formatMoney(displayTotal);
    });

    updateCheckoutButton(cart);
  }

  function updateGiftCards(root, cart, total) {
    root.querySelectorAll('[data-ne-gift-card]').forEach(function (card) {
      var cardThreshold = Number(card.dataset.cardThreshold || 0);
      var subtitle = card.querySelector('.ne-gift-subtitle');
      var removeBtn = card.querySelector('[data-ne-remove-gift]');

      card.classList.toggle('is-locked', total < cardThreshold);

      if (removeBtn) {
        var removeVariantId = removeBtn.dataset.removeVariant;
        card.classList.toggle('has-gift-in-cart', giftInCart(cart, removeVariantId));
      }

      if (subtitle) {
        if (total >= cardThreshold) {
          subtitle.textContent = COPY.giftUnlocked;
        } else {
          subtitle.textContent = COPY.giftLocked.replace('%s', formatMoney(cardThreshold, true));
        }
      }
    });

    root.querySelectorAll('[data-ne-add-selected-gift]').forEach(function (button) {
      var variantId = button.dataset.selectedVariant;
      var threshold = Number(button.dataset.selectedThreshold || 0);

      var showManualButton =
        variantId &&
        total >= threshold &&
        !giftInCart(cart, variantId) &&
        isGiftSuppressed(variantId);

      button.disabled = !showManualButton;
      button.textContent = showManualButton ? COPY.giftAddButton : '';
      button.classList.toggle('is-manual-visible', showManualButton);
    });
  }

  function render(cart) {
    var roots = document.querySelectorAll('[data-ne-gift-root]');
    var total = getDiscountedCartTotalWithoutGifts(cart);
    var progress = getProgress(total);

    roots.forEach(function (root) {
      root.style.setProperty('--ne-progress', progress + '%');

      var topTitle = root.querySelector('[data-ne-progress-title]');
      var greenMessage = root.querySelector('[data-ne-gift-message]');
      var goals = root.querySelectorAll('[data-ne-goal]');

      if (topTitle) {
        topTitle.innerHTML = getTopMessage(total);
      }

     if (greenMessage) {
  var nextGreenMessage = getGreenMessage(total);

  if (greenMessage.getAttribute('data-ne-last-message') !== nextGreenMessage) {
    greenMessage.innerHTML = nextGreenMessage;
    greenMessage.setAttribute('data-ne-last-message', nextGreenMessage);
  }
  }

      goals.forEach(function (goal) {
        goal.classList.toggle('reached', total >= Number(goal.dataset.neGoal || 0));
      });

      updateGiftCards(root, cart, total);
    });

    updateCheckoutButton(cart);
  }

  function dispatchCartEvents(cart) {
    isDispatchingInternalEvent = true;

    try {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
    } finally {
      isDispatchingInternalEvent = false;
    }
  }

  function refreshQuickCartSection() {
    var quickCart = document.querySelector('.quick-cart[data-section-id]');
    if (!quickCart) return Promise.resolve();

    var sectionId = quickCart.getAttribute('data-section-id');
    if (!sectionId) return Promise.resolve();

    return fetch(cartUrl('/cart') + '?section_id=' + encodeURIComponent(sectionId) + '&t=' + Date.now(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'text/html'
      },
      cache: 'no-store'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Section refresh failed');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var newItemsWrap = doc.querySelector('.quick-cart__items');
        var currentItemsWrap = document.querySelector('.quick-cart__items');

        if (newItemsWrap && currentItemsWrap) {
          var currentCrossSells = currentItemsWrap.querySelector('[data-cross-sells], .cross-sells');

          currentItemsWrap.querySelectorAll('.quick-cart__item').forEach(function (item) {
            item.remove();
          });

          newItemsWrap.querySelectorAll('.quick-cart__item').forEach(function (item) {
            var clonedItem = item.cloneNode(true);

            if (currentCrossSells) {
              currentItemsWrap.insertBefore(clonedItem, currentCrossSells);
            } else {
              currentItemsWrap.appendChild(clonedItem);
            }
          });
        }

        var newFooter = doc.querySelector('.quick-cart__footer');
        var currentFooter = document.querySelector('.quick-cart__footer');

        if (newFooter && currentFooter) {
          currentFooter.innerHTML = newFooter.innerHTML;
        }

        var newHeading = doc.querySelector('.quick-cart__heading');
        var currentHeading = document.querySelector('.quick-cart__heading');

        if (newHeading && currentHeading) {
          currentHeading.innerHTML = newHeading.innerHTML;
        }

        document.dispatchEvent(new CustomEvent('quick-cart:updated'));
        document.dispatchEvent(new CustomEvent('cart:items-updated'));
      })
      .catch(function (err) {
        console.warn('[NE gift] quick cart section refresh failed', err);
      });
  }

  function refreshCartUi(cart) {
    return refreshQuickCartSection()
      .then(function () {
        return fetchCart(true);
      })
      .then(function (freshCart) {
        render(freshCart);
        syncQuickCartGiftPrices(freshCart);
        return freshCart;
      });
  }

  function showGiftRemovedToast(count) {
    var oldToast = document.querySelector('.ne-gift-toast');

    if (oldToast) {
      oldToast.remove();
    }

    var toast = document.createElement('div');
    toast.className = 'ne-gift-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');

    var icon = document.createElement('span');
    icon.className = 'ne-gift-toast__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '⚠';

    var text = document.createElement('span');
    text.className = 'ne-gift-toast__text';
    text.textContent = count > 1
      ? COPY.removedToastPlural
      : COPY.removedToast;

    toast.appendChild(icon);
    toast.appendChild(text);
    document.body.appendChild(toast);

    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });

    setTimeout(function () {
      toast.classList.remove('is-visible');

      setTimeout(function () {
        if (toast && toast.parentNode) {
          toast.parentNode.removeChild(toast);
        }
      }, 300);
    }, 4000);
  }

  function removeGiftItem(item) {
    return fetch(cartUrl('/cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: item.key,
        quantity: 0
      })
    });
  }

  function removeInvalidGifts(cart) {
    if (isRemovingInvalidGifts) return Promise.resolve(cart);

    clearSuppressedGiftsBelowThreshold(cart);

    var total = getDiscountedCartTotalWithoutGifts(cart);

    var giftsToRemove = getGiftItems(cart).filter(function (item) {
      var giftThreshold = getGiftThresholdFromItem(item);

      if (!giftThreshold) return false;

      return total < giftThreshold;
    });

    if (!giftsToRemove.length) {
      return Promise.resolve(cart);
    }

    var removedGiftCount = giftsToRemove.length;
    isRemovingInvalidGifts = true;

    return giftsToRemove.reduce(function (promise, item) {
      return promise.then(function () {
        return removeGiftItem(item);
      });
    }, Promise.resolve())
      .then(function () {
        return fetchCart(true);
      })
      .then(function (updatedCart) {
        return refreshCartUi(updatedCart);
      })
      .then(function (freshCart) {
        showGiftRemovedToast(removedGiftCount);
        dispatchCartEvents(freshCart);
        return freshCart;
      })
      .finally(function () {
        isRemovingInvalidGifts = false;
      });
  }

  function addGiftItem(variantId, threshold) {
    var properties = {
      _is_free_gift: 'true',
      _gift_threshold: String(threshold)
    };

    properties[COPY.giftPropertyLabel] = COPY.giftPropertyValue;

    return fetch(cartUrl('/cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        properties: properties
      })
    }).then(function (res) {
      if (!res.ok) throw new Error('Auto gift add failed');
      return res.json();
    });
  }

  function autoAddEligibleGifts(cart) {
    if (isAutoAddingGift || isRemovingInvalidGifts) {
      return Promise.resolve(cart);
    }

    clearSuppressedGiftsBelowThreshold(cart);

    var total = getDiscountedCartTotalWithoutGifts(cart);
    var giftsToAdd = [];

    if (
      HAS_GIFT_1 &&
      GIFT_VARIANTS.gift1 &&
      total >= THRESHOLDS.gift1 &&
      !giftInCart(cart, GIFT_VARIANTS.gift1) &&
      !isGiftSuppressed(GIFT_VARIANTS.gift1)
    ) {
      giftsToAdd.push({
        variantId: GIFT_VARIANTS.gift1,
        threshold: THRESHOLDS.gift1
      });
    }

    if (
      HAS_THIRD_GOAL &&
      THIRD_GOAL_TYPE !== 'discount' &&
      GIFT_VARIANTS.gift2 &&
      total >= THRESHOLDS.gift2 &&
      !giftInCart(cart, GIFT_VARIANTS.gift2) &&
      !isGiftSuppressed(GIFT_VARIANTS.gift2)
    ) {
      giftsToAdd.push({
        variantId: GIFT_VARIANTS.gift2,
        threshold: THRESHOLDS.gift2
      });
    }

    if (!giftsToAdd.length) {
      return Promise.resolve(cart);
    }

    isAutoAddingGift = true;

    return giftsToAdd.reduce(function (promise, gift) {
      return promise.then(function () {
        return fetchCart(true).then(function (latestCart) {
          if (getDiscountedCartTotalWithoutGifts(latestCart) < gift.threshold) {
            return latestCart;
          }

          if (giftInCart(latestCart, gift.variantId)) {
            return latestCart;
          }

          if (isGiftSuppressed(gift.variantId)) {
            return latestCart;
          }

          return addGiftItem(gift.variantId, gift.threshold).then(function () {
            return fetchCart(true);
          });
        });
      });
    }, Promise.resolve(cart))
      .then(function () {
        return fetchCart(true);
      })
      .then(function (freshCart) {
        return refreshCartUi(freshCart);
      })
      .then(function (freshCart) {
        dispatchCartEvents(freshCart);
        return freshCart;
      })
      .catch(function (err) {
        console.warn('[NE gift auto add]', err);
        return cart;
      })
      .finally(function () {
        isAutoAddingGift = false;
      });
  }

  function manuallyAddGift(button) {
    var variantId = button.dataset.selectedVariant;
    var threshold = Number(button.dataset.selectedThreshold || 0);

    if (!variantId || !threshold) return;

    button.disabled = true;

    unsuppressGiftVariant(variantId);

    fetchCart(true)
      .then(function (cart) {
        if (getDiscountedCartTotalWithoutGifts(cart) < threshold) return cart;
        if (giftInCart(cart, variantId)) return cart;

        return addGiftItem(variantId, threshold).then(function () {
          return fetchCart(true);
        });
      })
      .then(function (cart) {
        return refreshCartUi(cart);
      })
      .then(function (cart) {
        dispatchCartEvents(cart);
      })
      .catch(function (err) {
        console.warn('[NE gift manual add]', err);
        syncCart();
      });
  }

  function syncCart(cart) {
    if (isSyncingCart) {
      hasQueuedSync = true;
      queuedCart = cart && Array.isArray(cart.items) ? cart : null;
      return Promise.resolve();
    }

    isSyncingCart = true;

    var cartPromise = cart && Array.isArray(cart.items)
      ? Promise.resolve(cart)
      : fetchCart(true);

    return cartPromise
      .then(removeInvalidGifts)
      .then(function (cart) {
        render(cart);
        syncQuickCartGiftPrices(cart);
        return autoAddEligibleGifts(cart);
      })
      .then(function (cart) {
        render(cart);
        syncQuickCartGiftPrices(cart);
        return cart;
      })
      .catch(function (err) {
        console.warn('[NE gift sync]', err);
      })
      .finally(function () {
        isSyncingCart = false;

        if (hasQueuedSync) {
          var nextCart = queuedCart;
          hasQueuedSync = false;
          queuedCart = null;
          syncCart(nextCart);
        }
      });
  }

  var milestoneLayoutFrame = null;

  function spaceMobileMilestones() {
    if (milestoneLayoutFrame) {
      window.cancelAnimationFrame(milestoneLayoutFrame);
    }

    milestoneLayoutFrame = window.requestAnimationFrame(function () {
      milestoneLayoutFrame = null;

      var root = document.querySelector('[data-ne-gift-root]');
      if (!root) return;

      var container = root.querySelector('.ne-gift-milestones');
      if (!container) return;

      var milestones = Array.prototype.slice.call(container.querySelectorAll('.ne-gift-milestone'));

      milestones.forEach(function (milestone) {
        milestone.style.removeProperty('left');
        milestone.style.removeProperty('transform');
      });

      if (!window.matchMedia('(max-width: 780px)').matches || milestones.length < 2) return;

      var containerRect = container.getBoundingClientRect();
      if (containerRect.width <= 0) return;

      var minimumGap = 8;
      var widths = milestones.map(function (milestone) {
        return milestone.getBoundingClientRect().width;
      });
      var positions = milestones.map(function (milestone, index) {
        var rect = milestone.getBoundingClientRect();
        return Math.max(0, Math.min(rect.left - containerRect.left, containerRect.width - widths[index]));
      });

      for (var index = 1; index < positions.length; index++) {
        positions[index] = Math.max(positions[index], positions[index - 1] + widths[index - 1] + minimumGap);
      }

      positions[positions.length - 1] = Math.min(
        positions[positions.length - 1],
        containerRect.width - widths[widths.length - 1]
      );

      for (var reverseIndex = positions.length - 2; reverseIndex >= 0; reverseIndex--) {
        positions[reverseIndex] = Math.min(
          positions[reverseIndex],
          positions[reverseIndex + 1] - widths[reverseIndex] - minimumGap
        );
      }

      if (positions[0] < 0) {
        positions[0] = 0;

        for (var forwardIndex = 1; forwardIndex < positions.length; forwardIndex++) {
          positions[forwardIndex] = positions[forwardIndex - 1] + widths[forwardIndex - 1] + minimumGap;
        }
      }

      milestones.forEach(function (milestone, index) {
        milestone.style.left = positions[index] + 'px';
        milestone.style.transform = 'none';
      });
    });
  }

  function syncFromEvent(event) {
    if (isDispatchingInternalEvent) return;

    var cart = event && event.detail && event.detail.cart;

    if (event && event.type === 'quick-cart:open') {
      persistCampaignFromUrl().then(function (persistedCart) {
        syncCart(persistedCart || cart).then(spaceMobileMilestones);
      });
      return;
    }

    syncCart(cart).then(spaceMobileMilestones);
  }

  document.addEventListener('click', function (event) {
    var removeGiftButton = event.target.closest('[data-ne-remove-gift]');

    if (removeGiftButton) {
      event.preventDefault();
      event.stopPropagation();

      var variantId = removeGiftButton.dataset.removeVariant;

      fetchCart(true)
        .then(function (cart) {
          var giftItem = getGiftItems(cart).find(function (item) {
            return String(item.variant_id) === String(variantId);
          });

          if (!giftItem) return cart;

          suppressGiftVariant(variantId);

          return removeGiftItem(giftItem).then(function () {
            return fetchCart(true);
          });
        })
        .then(function (cart) {
          return refreshCartUi(cart);
        })
        .then(function (cart) {
          showGiftRemovedToast(1);
          dispatchCartEvents(cart);
          return cart;
        })
        .catch(function (err) {
          console.warn('[NE gift remove button]', err);
          syncCart();
        });

      return;
    }

    var manualGiftButton = event.target.closest('[data-ne-add-selected-gift]');

    if (manualGiftButton) {
      event.preventDefault();
      event.stopPropagation();
      manuallyAddGift(manualGiftButton);
      return;
    }

    var removeButton = event.target.closest(
      '[data-remove-item], .quick-cart__item-remove, .cart-item__remove, [data-cart-item-remove], a[href*="/cart/change"][href*="quantity=0"]'
    );

    if (removeButton) {
      var line = removeButton.closest('.quick-cart__item[data-key], [data-key]');
      var removedGiftVariantId = getGiftVariantFromCartLine(line, window.cartData);

      if (removedGiftVariantId) {
        suppressGiftVariant(removedGiftVariantId);
      } else if (!window.cartData) {
        fetchCart(false).then(function (cart) {
          var fetchedGiftVariantId = getGiftVariantFromCartLine(line, cart);

          if (fetchedGiftVariantId) {
            suppressGiftVariant(fetchedGiftVariantId);
          }
        });
      }
    }
  }, true);

  [
    'quick-cart:open',
    'cart:refresh',
    'cart:updated',
    'discount:updated'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, syncFromEvent);
  });

  function init() {
    persistCampaignFromUrl().then(function (cart) {
      syncCart(cart).then(spaceMobileMilestones);
    });
  }

  window.addEventListener('resize', spaceMobileMilestones);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  })();
